import { BaseFieldComponentDescription, BaseFieldComponentHandler } from "./base-field";
import { ColumnPropertyHandler, ColumnPropertyFlag } from "./property-handlers";
import { PropertySection } from "./property-sections";
import {
    ComponentBuilder,
    ComponentConfiguratorContext,
    ComponentDescriptor,
    WireInflationBackend,
    WireRowComponentHydrator,
} from "./index";
import { getPrimitiveColumns, InputOutputTables, TableGlideType, MutatingScreenKind } from "../description";
import { SerializedComponent } from "../../components/SerializedApp";
import { getDocURL } from "../../docUrl";
import { WireComponentKind } from "../../wire/component-kind";
import { asString } from "../../components/component-helpers";

const ComponentKindEmailField = "email-field";

const propertyNamePropertyHandler = new ColumnPropertyHandler<EmailFieldComponentDescription>(
    "propertyName",
    "Column",
    [
        ColumnPropertyFlag.Required,
        ColumnPropertyFlag.Editable,
        ColumnPropertyFlag.EditedInApp,
        ColumnPropertyFlag.DefaultCaption,
        ColumnPropertyFlag.Searchable,
    ],
    undefined,
    ["email"],
    getPrimitiveColumns,
    "string",
    PropertySection.Data
);

interface EmailFieldComponentDescription extends BaseFieldComponentDescription {}

export class EmailFieldComponentHandler extends BaseFieldComponentHandler<EmailFieldComponentDescription> {
    constructor() {
        super(ComponentKindEmailField, "email-address");
    }

    public needValidation(): boolean {
        return true;
    }

    public entryForTableColumn(
        builder: ComponentBuilder,
        desc: EmailFieldComponentDescription,
        tables: InputOutputTables,
        mutatingScreenKind: MutatingScreenKind | undefined,
        validFlag: SerializedComponent | undefined,
        outputContext: SerializedComponent
    ): SerializedComponent {
        return this.fieldEntryForTableColumn(
            builder,
            desc,
            tables.output,
            outputContext,
            mutatingScreenKind,
            "email",
            propertyNamePropertyHandler,
            "EmailField",
            validFlag
        );
    }

    public getDescriptor(
        _desc: EmailFieldComponentDescription,
        _table: TableGlideType | undefined,
        ccc: ComponentConfiguratorContext,
        mutatingScreenKind: MutatingScreenKind | undefined
    ): ComponentDescriptor<EmailFieldComponentDescription> {
        return this.getFieldDescriptor(
            ccc,
            "Email Entry",
            "Edit an email address",
            "Entry Fields",
            "componentEmailEntry",
            propertyNamePropertyHandler,
            false,
            getDocURL("emailField"),
            mutatingScreenKind,
            "Email"
        );
    }

    public inflate(
        ib: WireInflationBackend,
        desc: EmailFieldComponentDescription
    ): WireRowComponentHydrator | undefined {
        return super.inflateComponent(ib, desc, (base, value, token) => ({
            ...base,
            kind: WireComponentKind.PhoneField,
            value: { value: asString(value), onChangeToken: token },
        }));
    }

    public makeValidationFlag(): SerializedComponent | undefined {
        return undefined;
    }
}
